var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success__notification-wrapper shadow text-center"},[_c('strong',{staticClass:"text-success pt-4"},[_vm._v(_vm._s(_vm.$t('notification.success')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }